import axios from 'axios'
import { DateString } from '@weblite/ts-action'
import { getClientUserIdentityToken } from '$logic/auth'
import { ResGetStats } from './types'
const baseURL = import.meta.env.VITE_PLANNER_API_URL

const axiosInstance = axios.create({
  baseURL,
})

export const getAllTrials = async () => {
  const token = await getClientUserIdentityToken()
  const response = await axiosInstance.get<{
    onlineClass?: {
      createdAt: DateString
    }
    recording?: {
      createdAt: DateString
    }
    vod?: {
      createdAt: DateString
    }
  }>('/trial', {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  return response.data
}

export const createTrial = async () => {
  const token = await getClientUserIdentityToken()
  const response = await axiosInstance.post<{}>(
    '/trial',
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  )
  return response.data
}

export const getPlannerStats = async () => {
  const token = await getClientUserIdentityToken()
  const response = await axiosInstance.get<ResGetStats>('/stats', {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  return response.data
}
